import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { State } from '../../graphql/states.datatypes';

export interface StateData {
    states: State[];
}

export const gqlState = `
    id,
    name,
    abbreviation,
    credit_card_fee {
        id,
        fee,
        type,
        type_id
    }
`;

export const GET_STATES = gql`
    query states{
        states{
            ${gqlState}
        }
    }
`;

export const getStates = () => {
    return useQuery<StateData>(GET_STATES);
};

export default getStates;
